import { getFeedRoute, getRoute } from "@libs/layouts"
import { __ } from "@libs/utilities"
import { IAds } from "@/modules/pe-topos-module/data/interfaces"
import { Link } from "react-router-dom"
import { ITrack } from "../../data/interfaces"
import TrackAdAdd from "../projectList/filter-terms/TrackAdAdd"

/* Protopia Ecosystem component */
export interface ITrackLastAdlabelProps {
   item?: IAds
   track: ITrack | null
}
const TrackLastAdlabel = (props: ITrackLastAdlabelProps): JSX.Element => {
    return <div className='pe-track-last-ad-label-container d-flex flex-wrap flex-md-no-wrap py-1 px-4 mb-md-0 mb-4 align-items-center'>
        <div className="width-200 min-width-200 max-width-200 d-flex">
            <div className="small mr-3 text-no-break">{ __( "Last add" ) }:</div>
        </div>            
        <i className="far fa-newspaper mr-3" />
        <div className="mt-md-0 mt-3">
            {
                props.item 
                    ?
                    <>
                        <div className="small title text-uppercase" dangerouslySetInnerHTML={{ __html: props.item!.title }} />
                        <div className="position-relative">
                            {
                                props.item?.thumbnail && <img src={props.item?.thumbnail} alt="" style={{height: 100, float: "left", marginRight: 10, marginBottom: 4 }}/>
                            }
                        </div>
                        <div className="small opacity_75" dangerouslySetInnerHTML={{ __html: props.item!.post_content }} /> 
                    </>
                    :
                    <></>
            } 
            <div className="d-flex align-items-center">
                <Link className="btn btn-link small" to={`/${getRoute( getFeedRoute("Ad") )}`}>
                    <span className="small">
                        {__("Ads archive")}
                    </span>
                </Link> 
                <TrackAdAdd track={ props.track! } />
            </div>                
        </div>
    </div> 
}
export default TrackLastAdlabel